import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import * as SLHelper from 'helpers/seaLice'
import { getCurrentDate } from 'helpers/seaLice'

// constants
export const FETCH_SEA_LICE_DATA = 'seaLice/FETCH_SEA_LICE_DATA'
export const SUCCESS_SEA_LICE_DATA = 'seaLice/SUCCESS_SEA_LICE_DATA'
export const FAILURE_SEA_LICE_DATA = 'seaLice/FAILURE_SEA_LICE_DATA'
export const FETCH_LAST_SEA_LICE_DATE = 'seaLice/FETCH_LAST_SEA_LICE_DATE'
export const [
  FETCH_LAST_SEA_LICE_DATE_SUCCESS,
  FETCH_LAST_SEA_LICE_DATE_FAILURE,
] = [
  `${FETCH_LAST_SEA_LICE_DATE}_SUCCESS`,
  `${FETCH_LAST_SEA_LICE_DATE}_FAILURE`,
]
export const SET_ACTIVE_SITE = 'seaLice/SET_ACTIVE_SITE'
export const SET_ACTIVE_DATE = 'seaLice/SET_ACTIVE_DATE'
export const SET_ACTIVE_VIEW = 'seaLice/SET_ACTIVE_VIEW'
export const SET_ACTIVE_BARRIOS = 'seaLice/SET_ACTIVE_BARRIOS'
export const SET_ACTIVE_SPESIES = 'seaLice/SET_ACTIVE_SPESIES'
export const SET_ACTIVE_TYPE = 'seaLice/SET_ACTIVE_TYPE'
export const FETCH_SPECIES_LIST = 'seaLice/FETCH_SPECIES_LIST'
export const SET_SPECIES_LIST = 'seaLice/SET_SPECIES_LIST'
export const FETCH_BARRIOS_ACTIVE_LIST = 'seaLice/FETCH_BARRIOS_ACTIVE_LIST'
export const SET_BARRIOS_ACTIVE_LIST = 'seaLice/SET_BARRIOS_ACTIVE_LIST'
export const SET_ACTIVE_MAP = 'seaLice/SET_ACTIVE_MAP'
export const SET_MARKER_PARAMS = 'seaLice/SET_MARKER_PARAMS'
export const CLOSE_MARKER_INFO = 'seaLice/CLOSE_MARKER_INFO'
export const SET_ACTIVE_WEEK = 'seaLice/SET_ACTIVE_WEEK'
export const CLEAR_ACTIVE_BARRIO = 'seaLice/CLEAR_ACTIVE_BARRIO'
export const SET_MAP_POSITION = 'seaLice/SET_MAP_POSITION'

// actions
export const fetchSeaLiceData = ActionHelper.createActionObj(
  FETCH_SEA_LICE_DATA,
)
export const fetchLastSeaLiceDate = ActionHelper.createActionObj(
  FETCH_LAST_SEA_LICE_DATE,
)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveDate = ActionHelper.createActionObj(SET_ACTIVE_DATE)
export const setActiveView = ActionHelper.createActionObj(SET_ACTIVE_VIEW)
export const setActiveBarrios = ActionHelper.createActionObj(SET_ACTIVE_BARRIOS)
export const setActiveSpecies = ActionHelper.createActionObj(SET_ACTIVE_SPESIES)
export const setActiveType = ActionHelper.createActionObj(SET_ACTIVE_TYPE)
export const fetchSpeciesList = ActionHelper.createActionObj(FETCH_SPECIES_LIST)
export const fetchActiveBarriosList = ActionHelper.createActionObj(
  FETCH_BARRIOS_ACTIVE_LIST,
)
export const setActiveMap = ActionHelper.createActionObj(SET_ACTIVE_MAP)
export const setMarkerParams = ActionHelper.createActionObj(SET_MARKER_PARAMS)
export const onCloseMarkerInfo = ActionHelper.createActionObj(CLOSE_MARKER_INFO)
export const clearActiveBarrio = ActionHelper.createActionObj(
  CLEAR_ACTIVE_BARRIO,
)
export const setMapPosition = ActionHelper.createActionObj(SET_MAP_POSITION)

const initialState = fromJS({
  markerParams: {},
  sitesData: [],
  speciesList: [],
  barriosList: [],
  activeView: SLHelper.LIST_VIEW_ALL_SITES,
  activeMap: SLHelper.FILTER_MAP_VIEW,
  activeSpecies: null,
  activeBarrios: null,
  activeSite: null,
  activeWeek: 20,
  activeType: SLHelper.TYPE_FEMALES,
  activeDate: null,
  mapPosition: null,
  seaLiceLoader: false,
})

const seaLice = handleActions(
  {
    [FETCH_SEA_LICE_DATA]: state => state.set('seaLiceLoader', true),
    [SUCCESS_SEA_LICE_DATA]: (state, action) =>
      state.set('sitesData', List(action.payload)).set('seaLiceLoader', false),
    [FAILURE_SEA_LICE_DATA]: state =>
      state
        .set('sitesData', initialState.get('sitesData'))
        .set('seaLiceLoader', false),
    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', action.payload),
    [FETCH_LAST_SEA_LICE_DATE_SUCCESS]: (state, action) =>
      state.set('activeDate', getCurrentDate(action.payload.lastDate)),
    [SET_ACTIVE_WEEK]: (state, action) =>
      state.set('activeWeek', action.payload),
    [SET_ACTIVE_DATE]: (state, action) =>
      state.set('activeDate', action.payload),
    [SET_ACTIVE_VIEW]: (state, action) =>
      state.set('activeView', action.payload),
    [SET_ACTIVE_BARRIOS]: (state, action) =>
      state.set('activeBarrios', action.payload),
    [SET_ACTIVE_SPESIES]: (state, action) =>
      state.set('activeSpecies', action.payload),
    [SET_ACTIVE_TYPE]: (state, action) =>
      state.set('activeType', action.payload),
    [SET_ACTIVE_MAP]: (state, action) => state.set('activeMap', action.payload),
    [SET_SPECIES_LIST]: (state, action) =>
      state.set('speciesList', List(action.payload.list)),
    [SET_BARRIOS_ACTIVE_LIST]: (state, action) =>
      state.set('barriosList', List(action.payload.list)),
    [SET_MARKER_PARAMS]: (state, action) =>
      state.set('markerParams', Map(action.payload)),
    [CLOSE_MARKER_INFO]: state =>
      state.set('markerParams', initialState.get('markerParams')),
    [CLEAR_ACTIVE_BARRIO]: state =>
      state.set('activeBarrios', initialState.get('activeBarrios')),
    [SET_MAP_POSITION]: (state, action) =>
      state.set('mapPosition', Map(action.payload)),
  },
  initialState,
)

export default seaLice
